import { withInternetuLegacySlugs } from '@/lib/calculatorSlugs.mjs';

/** Canonical PCA (construction supervisor liability) calculator slug. */
export const PCA_INSURANCE_SLUG =
  'statybu-techninio-priziuretojo-civilines-atsakomybes-privalomasis-draudimas-internetu';

const PCA_FLOW_SLUGS = withInternetuLegacySlugs([PCA_INSURANCE_SLUG]);

export function isPcaInsuranceSlug(slug) {
  return PCA_FLOW_SLUGS.has(slug);
}

export function isPcaInsuranceType(type) {
  return type === 'pca';
}

export function isPcaInsuranceFlow({ slug, type } = {}) {
  return isPcaInsuranceType(type) || isPcaInsuranceSlug(slug);
}
